module.exports = __webpack_public_path__ + "static/img/casa_25q1.96dd9f5.jpg";